module.exports = __webpack_public_path__ + "media/images/pc/top/keyword_flower@3x-fc979acef29c585b13bf7425c2a18e1c.webp";